import get from 'lodash/get';

export default function finalizeTimeline(dispatch, getState, { messageGateway }) {
  let { searchTerm, timeline } = getState().selfService;
  let finalTimeline = timeline.concat([]);

  // append last search term if it wasn't already added by clicking into an answer
  if (searchTerm && get(timeline[timeline.length - 1], 'searchTerm') !== searchTerm) {
    finalTimeline.push({ searchTerm });
  }

  messageGateway.setSelfServiceTimeline(finalTimeline);
}
